import { ErrorHandler, Injectable, Injector } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { environment } from '@environment';
import { LoggerService } from '@shared/core/services/logger.service';

@Injectable()
export class CrmErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {
    Sentry.init({
      enabled: environment.sentry.enabled,
      dsn: environment.sentry.dsn,
      release: environment.sentry.release,
    });
  }

  handleError(error: any): void {
    this.injector.get(LoggerService).error('[ErrorHandler]', error);

    if (!this.ignoreError(error)) {
      Sentry.captureException(error.nativeError || error.originalError || error);
    }

    this.handleLoadingChunkFailed(error);
  }

  private ignoreError(error: Error): boolean {
    return this.isConnectionError(error) || this.isLoadingChunkFailed(error) || this.isMobile();
  }

  private isConnectionError(error: Error): boolean {
    const expectedStatusText = 'Unknown Error';

    const errorText = error.toString();

    return errorText.includes(`"status":0`) && errorText.includes(`"statusText":"${expectedStatusText}"`);
  }

  private isLoadingChunkFailed(error: Error): boolean {
    const chunkFailedMessage = /Loading chunk .+? failed/i;

    return chunkFailedMessage.test(error.message);
  }

  private isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  private handleLoadingChunkFailed(error: Error): void {
    if (this.isLoadingChunkFailed(error)) {
      window.location.reload();
    }
  }
}
